import VueLogger from 'vuejs-logger';
import Vue from 'vue';
import Config from '../../core/config/config';

const isProduction = Config.isProduction();

const options = {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};

Vue.use(VueLogger, options);

export default Vue.prototype.$log;

/**
 * 使用
 *  // these statements will print nothing if the logLevel is set to 'fatal'. But they will compile just fine.
 this.$log.debug('test', 'bar')
 this.$log.info('test')
 this.$log.warn('test')
 this.$log.error('test', 'foo')
 // this statement will print if the logLevel is set to 'fatal'
 this.$log.fatal('test', 'bar', 123)
 */
